<template>
  <div>
    <b-modal
      id="add_new_member"
      title="Add New Lead 新增潛在客戶"
      ref="add_new_member"
      no-close-on-backdrop
      centered
      cancel-variant="outline-secondary"
    >
          <template #modal-footer="{ ok , closeModal  }">

      <b-button size="sm" variant="primary" @click="handleOk()" >
        Submit
      </b-button>
    </template>
      <b-form>
        <b-form-group
          label="姓名 Name"
          label-for="name"
        >
          <b-form-input
            id="name"
            placeholder="Enter name"
            v-model="form.zh_name"
          />
        </b-form-group>
        <b-form-group
          label="電子郵件 E-Mail"
          label-for="name"
          
        >
          <b-form-input
            id="email"
            placeholder="Enter E-Mail"
             v-model="form.email"
          />
        </b-form-group>
        <b-form-group
          label="手機 Mobile"
          label-for="mobile"
        >
          <b-form-input
            id="mobile"
             v-model="form.mobile"
            placeholder="Enter Mobile"
          />
        </b-form-group>
        <b-form-group
          label="性別 Gender"
          label-for="Gender"
        >
          <v-select
            id="gender"
            :reduce="option => option.value"
            v-model="form.gender"
            :options="[{ label: 'Male 男', value: 'M' }, { label: 'Female 女', value: 'F' }]"
          />
        </b-form-group>
        <hr class="my-2"/>
        <b-form-group
          label="Source 來源"
          label-for="Source"
        >
          <v-select
            id="Source"
            :reduce="option => option.id"
            v-model="form.source"
            :options="sourcesOptions"
            label="name"
          />
        </b-form-group>
        <b-form-group
          label="Campaign ID 活動編號"
          label-for="Campaign"
        >
          <b-form-input
            id="Campaign"
             v-model="form.campaign"
            placeholder="Enter Campaign ID"
          />
        </b-form-group>

        <hr class="my-2"/>
                                <b-form-group label="有意親臨的分店 Desired Branch" label-for="center">
                                    <v-select v-model="form.center" :reduce="center => center.value" :options="centerOptions" :clearable="false" input-id="centers" />
                                   
                                </b-form-group>
                      
                            
                             <b-form-group  label="親臨時間" label-for="center">
                          
                                <flat-pickr
                                v-model="form.appointment"
                                class="form-control"
                                :config="{ enableTime: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d H:i'}"
                                />
                            </b-form-group>



      </b-form>
    </b-modal>
    <b-card>
    <b-row>
      <b-col
        cols="12"
        md="7"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-form-group>
          <!-- <v-select
            v-model="perPage"
            label="Number of rows"
            :options="pageOptions"
            :clearable="false"
          /> -->
        </b-form-group>
      </b-col>

      <b-col
        cols="12"
        md="5"
      >
        <div class="d-flex align-items-center justify-content-end mb-1">
          <b-form-input
            v-model="searchString"
            ref="search"
            class="d-inline-block mr-1"
            :placeholder="$t('Search')+'...'"
          />
          <b-button
            variant="primary"
            @click="show_add()"
          >
            <span class="text-nowrap"> {{$t('Add Lead')}} </span>
          </b-button>
          
        </div>
      </b-col>
    </b-row>
    <!-- table -->
    <b-table
      ref="selectableTable"
      selectable
      :select-mode="selectMode"
      :items="items"
      :fields="fields"
      responsive
      striped
      @row-selected="onRowSelected"
    >
      <template #cell(actions)="data">
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >

          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-dropdown-item :to="{ name: 'apps-Member-view', params: { id: data.item.id } }">
            <feather-icon icon="FileTextIcon" />
            <span class="align-middle ml-50">Details</span>
          </b-dropdown-item>

          <b-dropdown-item :to="{ name: 'apps-Member-edit', params: { id: data.item.id } }">
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">Edit</span>
          </b-dropdown-item>

          <b-dropdown-item>
            <feather-icon icon="TrashIcon" />
            <span class="align-middle ml-50">Delete</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
      <template #cell(status_number)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>
    </b-table>
    <b-row>
      <b-col class="mt-1">
        Total : {{ totalRows }} , Display Row {{ startRow }} to {{ endRow }} , Page {{currentPage}}
      </b-col>
      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          align="right"
          size="md"
          class="my-0"
          @change="handleChangePage"
        />
      </b-col>
    </b-row>
  </b-card>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import vSelect from 'vue-select'

import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BTable, BAvatar, BCardBody, BCard, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'


export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCard,
    flatPickr,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BButton,
    BPagination,
    BCardCode,
    BTable,
    BButton,
    BFormGroup,
    BAvatar,
    BCardBody,
    BBadge,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      test_string : null,
      guestData:null,
      centerOptions: [],
      isAddNewMemberSidebarActive: false,
      searchString: null,
      rollback : false,
      sourcesOptions: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      form: {
        zh_name: null,
        email: null,
        mobile: null,
        center: null,
        appointment: null
      },
      perPage: 10,
      startRow: 1,
      endRow: 10,
      timer:null, 
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      fields: [
       // { key: 'leak_code', label: '#' , sortable: true},
        { key: 'lead_name', label: this.$t('Name') },
        { key: 'mobile', label: this.$t('Mobile') },
        { key: 'center_name', label: this.$t('Following Center') },
        { key: 'status_number', label: this.$t('Status')},
        { key: 'updated_at', label: this.$t('Last Update') , sortable: true},
         ],
      /* eslint-disable global-require */
      items: [],
      /* eslint-disable global-require */
      status: [{
        1: 'OPEN', 2: 'BOOK', 3: 'SHOW', 4: 'DONE', 5: 'LOST',
      },
      {
        1: 'primary', 2: 'info', 3: 'warning', 4: 'light-success', 5: 'light-dark',
      }],
      selectMode: 'single',
      selected: [],
    }
  },
  mounted() {
   this.$refs.search.$el.focus();
  },
  watch: {
    currentPage: {
      handler(newValue, oldValue) {
        this.$store.commit('lead_search/UPDATE_PAGE', newValue)
        this.get_data()
      },
    },
    searchString: {
      handler(newValue, oldValue) {
        this.searchString = newValue.toUpperCase()
        this.$store.commit('lead_search/UPDATE_KEYWORD', this.searchString)
        this.handleSearch()
      },
    },
    perPage: {
      handler(newValue, oldValue) {
        if (newValue < 9) {
          this.perPage = 10
        }
        // console.log("search")
        this.handleSearch()
      },
    },
  },
  created() {
  this.get_center_data()
  this.get_data()
  this.get_source_data()
    console.log(this.$store.getters['lead_search/page']+" & "+this.$store.getters['lead_search/keyword'])
    if (this.$store.getters['lead_search/keyword'] != '') {
      this.searchString = this.$store.getters['lead_search/keyword']
      this.rollback = true
    } else {
      this.get_data()
    }
      setTimeout(() => {
        if (this.$store.getters['lead_search/page'] > 1) {
          this.currentPage = this.$store.getters['lead_search/page']
        }
      }, 1000)
    localStorage.setItem('reader_action', 'normal')
  },
  methods: {
    handleOk() {
            this.$http.post(process.env.VUE_APP_API_BASE + '/lead-register/' + this.userData.client_id + '/', this.form)
                .then(res => {
                    if (res.data.result === true) {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Success',
                                icon: 'CheckCircleIcon',
                                variant: 'success',
                                text: 'New Lead Added',
                            },
                          })
                          this.$refs['add_new_member'].hide()
                          this.get_data()

                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })
        },
    show_add(){
      this.$refs['add_new_member'].show()
    },

    one() {
      this.isAddNewMemberSidebarActive = false
      this.guestData = null
      this.get_data()
    },
    get_data() {
      if (this.searchString == null || this.searchString == undefined) {
        this.searchString = ''
      }
      this.$http.get(process.env.VUE_APP_API_BASE+`/leads/?perpage=${this.perPage}&page=${this.currentPage}&search=${this.searchString}`)
        .then(res => {
          if (process.env.VUE_APP_VERSION != res.data.version) {
           // this.$router.go(0);
          }
          this.items = res.data.leads
          this.totalRows = res.data.total
          this.startRow = res.data.startRow
          this.endRow = res.data.endRow
        })
    },
    get_source_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/lead-sources/')
        .then(res => {
          this.sourcesOptions = res.data.sources
        })
    },
    get_center_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },
    handleChangePage() {

    //  this.get_data()
    },
    onRowSelected(items) {
      this.selected = items
      this.$router.push(`/apps/lead/edit/${items[0].id}/`)
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    selectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.selectRow(2)
    },
    unselectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.unselectRow(2)
    },

    handleSearch() {
      // let _print = `The user searched for: ${searching}\n`
      // this.$refs.pre.appendChild(document.createTextNode(_print))
    // this.searchString = searching
    // this.currentx = 1
    // this.get_data()
      this.searchTimeOut()
    },
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        // your code
        this.currentPage = 1
        this.get_data()
      }, 500)
    },
  },
}
</script>

<style lang="scss">
.b-table-selectable{
  .feather{
    font-size: 1.3rem;
  }
}

</style>
